var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 40,
    viewBox: "0 0 61 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81578 0L5.89699 3.32762H9.39587L6.56522 5.38421L7.64643 8.71183L4.81578 6.65525L1.98514 8.71183L3.06635 5.38421L0.235701 3.32762H3.73457L4.81578 0Z",
    fill: "#302150"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6595 0L18.7407 3.32762H22.2396L19.409 5.38421L20.4902 8.71183L17.6595 6.65525L14.8289 8.71183L15.9101 5.38421L13.0795 3.32762H16.5783L17.6595 0Z",
    fill: "#302150"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4955 0L31.5767 3.32762H35.0756L32.2449 5.38421L33.3261 8.71183L30.4955 6.65525L27.6648 8.71183L28.746 5.38421L25.9154 3.32762H29.4143L30.4955 0Z",
    fill: "#302150"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3431 0L44.4243 3.32762H47.9232L45.0926 5.38421L46.1738 8.71183L43.3431 6.65525L40.5125 8.71183L41.5937 5.38421L38.763 3.32762H42.2619L43.3431 0Z",
    fill: "#302150"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.183 0L57.2642 3.32762H60.7631L57.9324 5.38421L59.0136 8.71183L56.183 6.65525L53.3523 8.71183L54.4335 5.38421L51.6029 3.32762H55.1018L56.183 0Z",
    fill: "#302150"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.65d6f4e290ba7fbc06775989bc18b328.svg";
export { ForwardRef as ReactComponent };